var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMath1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.3125 14C3.3125 8.96186 3.3125 6.4428 4.87765 4.87765C6.4428 3.3125 8.96186 3.3125 14 3.3125C19.0381 3.3125 21.5572 3.3125 23.1224 4.87765C24.6875 6.4428 24.6875 8.96186 24.6875 14C24.6875 19.0381 24.6875 21.5572 23.1224 23.1224C21.5572 24.6875 19.0381 24.6875 14 24.6875C8.96186 24.6875 6.4428 24.6875 4.87765 23.1224C3.3125 21.5572 3.3125 19.0381 3.3125 14Z",
    fill: "url(#paint0_linear_5205_11671)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1967 8.09375L21.3126 8.09375C21.7786 8.09375 22.1563 8.47151 22.1563 8.9375C22.1563 9.40349 21.7786 9.78125 21.3126 9.78125H17.2435C16.4414 9.78125 15.9106 9.78253 15.5045 9.82889C15.1199 9.8728 14.9344 9.94947 14.7995 10.0467C14.6647 10.1439 14.5333 10.2956 14.37 10.6466C14.1976 11.0172 14.0285 11.5203 13.7749 12.2813L11.4255 19.3293C11.3136 19.6652 11.0038 19.8955 10.6499 19.9059C10.296 19.9163 9.97319 19.7046 9.84169 19.3759L8.10662 15.0382C8.05602 14.9117 8.01454 14.8081 7.97707 14.719C7.89571 14.7712 7.80284 14.8331 7.68948 14.9086L7.15562 15.2645C6.76789 15.523 6.24403 15.4183 5.98555 15.0305C5.72706 14.6428 5.83183 14.1189 6.21956 13.8605L6.79059 13.4798C7.02425 13.3239 7.26871 13.1608 7.48968 13.0553C7.74308 12.9342 8.10853 12.817 8.5274 12.9471C8.94627 13.0772 9.181 13.3808 9.32126 13.6241C9.44357 13.8363 9.55261 14.1092 9.65684 14.37L10.553 16.6105L12.1888 11.7032C12.4236 10.9986 12.6221 10.4031 12.84 9.93482C13.0715 9.43708 13.3585 9.0052 13.8129 8.67772C14.2672 8.35024 14.7677 8.21456 15.3131 8.15229C15.8262 8.0937 16.4539 8.09373 17.1967 8.09375Z",
    fill: "url(#paint1_linear_5205_11671)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8466 13.4034C16.5171 13.0739 15.9829 13.0739 15.6534 13.4034C15.3239 13.7329 15.3239 14.2671 15.6534 14.5966L16.7443 15.6875L15.6534 16.7784C15.3239 17.1079 15.3239 17.6421 15.6534 17.9716C15.9829 18.3011 16.5171 18.3011 16.8466 17.9716L17.9375 16.8807L19.0284 17.9716C19.3579 18.3011 19.8921 18.3011 20.2216 17.9716C20.5511 17.6421 20.5511 17.1079 20.2216 16.7784L19.1307 15.6875L20.2216 14.5966C20.5511 14.2671 20.5511 13.7329 20.2216 13.4034C19.8921 13.0739 19.3579 13.0739 19.0284 13.4034L17.9375 14.4943L16.8466 13.4034Z",
    fill: "url(#paint2_linear_5205_11671)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9357 2.46875H14.0643C16.5289 2.46874 18.4646 2.46872 19.976 2.67192C21.5247 2.88014 22.7535 3.31555 23.719 4.28103C24.6844 5.2465 25.1199 6.47529 25.3281 8.02403C25.5313 9.53536 25.5313 11.4711 25.5312 13.9356V14.0643C25.5313 16.5288 25.5313 18.4646 25.3281 19.976C25.1199 21.5247 24.6844 22.7535 23.719 23.719C22.7535 24.6844 21.5247 25.1199 19.976 25.3281C18.4646 25.5313 16.5289 25.5313 14.0644 25.5312H13.9357C11.4712 25.5313 9.53536 25.5313 8.02403 25.3281C6.47529 25.1199 5.2465 24.6844 4.28103 23.719C3.31555 22.7535 2.88014 21.5247 2.67192 19.976C2.46872 18.4646 2.46874 16.5289 2.46875 14.0643V13.9357C2.46874 11.4711 2.46872 9.53537 2.67192 8.02403C2.88014 6.47529 3.31555 5.2465 4.28103 4.28103C5.2465 3.31555 6.47529 2.88014 8.02403 2.67192C9.53537 2.46872 11.4711 2.46874 13.9357 2.46875ZM8.24888 4.34437C6.88727 4.52743 6.07395 4.87459 5.47427 5.47427C4.87459 6.07395 4.52743 6.88727 4.34437 8.24888C4.15804 9.63477 4.15625 11.4571 4.15625 14C4.15625 16.5429 4.15804 18.3652 4.34437 19.7511C4.52743 21.1127 4.87459 21.9261 5.47427 22.5257C6.07395 23.1254 6.88727 23.4726 8.24888 23.6556C9.63477 23.842 11.4571 23.8438 14 23.8438C16.5429 23.8438 18.3652 23.842 19.7511 23.6556C21.1127 23.4726 21.9261 23.1254 22.5257 22.5257C23.1254 21.9261 23.4726 21.1127 23.6556 19.7511C23.842 18.3652 23.8438 16.5429 23.8438 14C23.8438 11.4571 23.842 9.63477 23.6556 8.24888C23.4726 6.88727 23.1254 6.07395 22.5257 5.47427C21.9261 4.87459 21.1127 4.52743 19.7511 4.34437C18.3652 4.15804 16.5429 4.15625 14 4.15625C11.4571 4.15625 9.63477 4.15804 8.24888 4.34437Z",
    fill: "url(#paint3_linear_5205_11671)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5205_11671",
    x1: 14,
    y1: 3.3125,
    x2: 14,
    y2: 24.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0097BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5205_11671",
    x1: 14,
    y1: 2.46875,
    x2: 14,
    y2: 25.5312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0097BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5205_11671",
    x1: 14,
    y1: 2.46875,
    x2: 14,
    y2: 25.5312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0097BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5205_11671",
    x1: 14,
    y1: 2.46875,
    x2: 14,
    y2: 25.5312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0097BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMath1);
export default __webpack_public_path__ + "static/media/math_1.a794979897b0804805045a12d4888cc0.svg";
export { ForwardRef as ReactComponent };